
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenWeatherMetadata {

    appliedAt: moment.Moment;
    associatedOutageEventCount: number;
    associatedWeatherEpisodeCount: number;
    associationRule: string;
    categories: string[];
    countyCount: number;
    coverageYears: number[];
    datasetVersion: string;
    outageEventCount: number;
    precedingWindowHours: number;
    runId: string;
    sourceValidationStatus: string;
    studyPeriod: string;
    weatherEpisodeCount: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherMetadata: GenWeatherMetadata);

    constructor( input?: GenWeatherMetadata ) {
        if ( input && typeof input !== 'number' ) {
            if ( input.appliedAt && typeof input.appliedAt === 'string' ) {
                this.appliedAt = moment(input.appliedAt).utc();
            } else {
                this.appliedAt = input.appliedAt;
            }
            this.associatedOutageEventCount = input.associatedOutageEventCount; // int [number]
            this.associatedWeatherEpisodeCount = input.associatedWeatherEpisodeCount; // int [number]
            this.associationRule = input.associationRule; // string [string]
            this.categories = input.categories; // list [string]
            this.countyCount = input.countyCount; // int [number]
            this.coverageYears = input.coverageYears; // list [number]
            this.datasetVersion = input.datasetVersion; // string [string]
            this.outageEventCount = input.outageEventCount; // int [number]
            this.precedingWindowHours = input.precedingWindowHours; // float [number]
            this.runId = input.runId; // string [string]
            this.sourceValidationStatus = input.sourceValidationStatus; // string [string]
            this.studyPeriod = input.studyPeriod; // string [string]
            this.weatherEpisodeCount = input.weatherEpisodeCount; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherMetadata[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherMetadata(a));
        } else {
          return [];
        }
    }
}

